/** Shared with `FreeUserConversionModal` and pricing v2.1 before/after section. */
export type BeforeAfterExample = {
  title: string;
  before: string;
  after: string;
  description: string;
};

export const freeUserBeforeAfterExamples: BeforeAfterExample[] = [
  {
    title: "AI Headshots",
    before: "/assets/images/tools/before-3.png",
    after: "/assets/images/tools/ai-headshots-3-up-opt.png",
    description: "Professional headshots",
  },
  {
    title: "AI Photoshoot",
    before: "/assets/images/tools/before-3.png",
    after: "/assets/images/tools/ai-avatars-3.png",
    description: "Stunning profile pictures",
  },
  {
    title: "Change Hair",
    before: "/assets/images/tools/before-gray.png",
    after: "/assets/images/tools/change-hair-color-2.png",
    description: "Try new hairstyles",
  },
  {
    title: "Add Smile",
    before: "/assets/images/tools/before-gray.png",
    after: "/assets/images/tools/add-smile-2.png",
    description: "Perfect smile instantly",
  },
];
